module.exports = __webpack_public_path__ + "img/icon-card.4f0da273.png";